export const HISTORY = {
  CODE: {
    research: "00030301",
    consulting: "00030302",
    it: "00030303",
  },
};
